import React from 'react';
import { Chip } from "@mui/material";
export const ReviewedByChip = (props) => {
    const { name } = props;
    const labelText = 'Reviewed By: ' + name;
    return (React.createElement(Chip, { style: { background: '#00000014', color: '#2E7D32' }, label: labelText, size: 'small' }));
};
